import { Component, OnInit } from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {Actions, ofActionDispatched, Select} from '@ngxs/store';
import {PaymentStepState} from '../shared/map.state';
import {Observable, throwError} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Session} from '../../interfaces/session-data';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {TransactionService} from '../../services/transaction/transaction.service';
import {catchError, filter} from 'rxjs/operators';
import {SetPaymentStepOtt} from '../shared/map.actions';
import {MaskedData} from "../../interfaces/visa-src/MaskedData";

@Component({
  selector: 'app-click-to-pay',
  templateUrl: './click-to-pay.component.html',
  styleUrls: ['./click-to-pay.component.scss']
})
export class ClickToPayComponent implements OnInit {

  // loader
  color: ThemePalette = 'primary';
  value = 50;
  diameter = 60;

  // ngxs
  @Select(PaymentStepState) paymentStep$: Observable<object>;

  public paymentMethodStyling;
  public backButtonVisibility;
  public paymentMethod = 'mobicred';
  public paymentOptionsLoadedJustify = 'space-between !important';
  public username = new FormControl('', [Validators.required, Validators.email]);
  public password: string;
  public otp = new FormControl('', [Validators.required, Validators.pattern('[0-9]*')]);
  public mobicredLoginForm: FormGroup;
  public hide = true;
  public paymentStatus: String = '';
  public transactionStatus: String = '';
  public paymentStatusImgSrc: String = '';
  paymentMethodImg = '';
  public session: Session;
  otpState = false;
  // routes
  timeRemaining;
  // loading var
  public loading = true;

  // box-shadow
  public boxShadow = '0px 6px 12px 0px rgba(0,0,0,0.5 )';
  public maskedData: MaskedData;
  hidePgLogo = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private actions$: Actions,
    private transactionService: TransactionService
  ) {
    console.log('Click to pay component!!!');
    sessionStorage.setItem('selected-payment', 'click_to_pay');
    this.session = JSON.parse(sessionStorage.getItem('sessionData'));
    console.log('router state masked data', this.router.getCurrentNavigation()?.extras?.state?.maskedData)
    if (this.router.getCurrentNavigation()?.extras?.state?.maskedData) {
      this.maskedData = this.router.getCurrentNavigation()?.extras?.state?.maskedData;
      console.log('setting masked data to!', this.maskedData);
    }
    this.callInit();
    // router.events
    //   .pipe(
    //     filter(
    //       (events) => {
    //         return (events instanceof NavigationStart);
    //       }
    //     )
    //   )
    //   .subscribe((events: NavigationStart) => {
    //     if (events.navigationTrigger === 'popstate') {
    //       this.router.navigate([this.session.virtualRoute])
    //         .then((data) => {
    //           this.loading = false;
    //         });
    //     }
    //   });

  }

  callInit(): void {
    if (this.router.routerState.snapshot.url.indexOf(`${this.paymentMethod}/`) === -1) {
      // setTimeout(() => {
      this.loading = false;
      this.router.navigate(['virtual/click_to_pay/visa']);
      // }, 2000);
    } else {
      this.loading = false;
    }
  }

  ngOnInit(): void {
    sessionStorage.setItem('TRANSACTION_CONFIRMED_PAYMENT_METHOD', this.paymentMethod);
    this.hidePgLogo = this.session?.sessionDisplayInformation?.hidePgLogo === 'true';
    this.paymentStep$.pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  goBack(){
    this.router.navigate(['virtual']);
    sessionStorage.setItem('goBack', 'true');
  }

}
